export default __webpack_public_path__ + "static/media/s4.80c53775.jpg";